import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "./wmsApi";
import { WButton, WInput, WField } from "./WmsUi";

const BG = "https://images.pexels.com/photos/9305407/pexels-photo-9305407.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const ALLOWED = ["wms", "admin", "superadmin"];

export default function WmsLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await axios.post(`${API}/auth/login`, { email, password, remember_me: true });
      const role = r.data.user?.role;
      if (!ALLOWED.includes(role)) {
        toast.error("Account non abilitato a iTRACE WMS/MES");
        return;
      }
      localStorage.setItem("wms_token", r.data.token);
      onLogin(r.data.user);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-zinc-950">
      <div className="w-full md:w-[40%] flex flex-col justify-center px-6 md:px-14 py-10 relative z-10">
        <div className="mb-10">
          <p className="font-['Chivo'] font-black text-5xl md:text-6xl text-white tracking-tighter leading-none">
            i<span className="text-[#FF4500]">TRACE</span>
          </p>
          <p className="text-zinc-400 font-bold uppercase tracking-[0.3em] text-sm mt-2">WMS / MES</p>
          <div className="h-1 w-16 bg-[#FF4500] mt-4" />
          <p className="text-zinc-500 text-sm mt-4">Ricevimento merci · Etichettatura · Tracciabilità · Bilancio di massa</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <WField label={<span className="text-zinc-400">Email operatore</span>}>
            <WInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="operatore@giotto.it" autoComplete="username" required data-testid="wms-login-email" className="bg-zinc-900 border-zinc-700 text-white placeholder:text-zinc-600" />
          </WField>
          <WField label={<span className="text-zinc-400">Password</span>}>
            <WInput type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" required data-testid="wms-login-password" className="bg-zinc-900 border-zinc-700 text-white placeholder:text-zinc-600" />
          </WField>
          <WButton type="submit" variant="primary" className="w-full" disabled={loading} data-testid="wms-login-submit">
            {loading ? "Accesso..." : "Entra in iTRACE"}
          </WButton>
        </form>
        <p className="text-zinc-600 text-xs mt-8">Accesso riservato agli operatori autorizzati.</p>
      </div>
      <div className="hidden md:block flex-1 relative">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/65" />
        <div className="absolute bottom-10 left-10 right-10">
          <p className="font-['Chivo'] font-black text-3xl text-white tracking-tight">TUTTO DEVE TORNARE A ZERO.</p>
          <p className="text-zinc-300 mt-2 text-sm">Entrate − Uscite − Giacenza = 0 · Ogni pezzo tracciato, ogni etichetta sotto controllo.</p>
        </div>
      </div>
    </div>
  );
}
